import dayjs from 'dayjs';

export const SYDNEY_TIMEZONE = 'Australia/Sydney';

// Reference date is MONDAY 2 Jan 2023 - used to calculate cycles starting
// from Mondays
export const REFERENCE_DATE = dayjs('2023-01-02');
